import React, { useState } from "react";
import logo from "../assets/images/logo.png";
import appStore from "../assets/images/AppStore.png";
import googleStore from "../assets/images/GooglePlay.png";
import { HashLink } from "react-router-hash-link";
import { apiCall } from "../API/apiCall";
import { toast } from "react-toastify";

const Footer = () => {
  const [formData, setFormData] = useState({ email: "" });
  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);

  const handlechange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailRegex =
      /^(?!\.)(?!.*\.\.)[a-zA-Z0-9._%+-]+@(?!\.)(?!.*\.\.)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const trimmedEmail = formData.email.trim();
    // 2. Validation Logic
    if (!trimmedEmail) {
      return toast.error("Email Address is required.");
    }
    if (!emailRegex.test(trimmedEmail)) {
      return toast.error("Please enter a valid email address.");
    }

    // 3. Proceed with API call
    setLoading(true);
    try {
      const response = await apiCall({
        url: "/admin/createnewLetter",
        method: "POST",
        data: {
          email: trimmedEmail, // Send the cleaned email
        },
      });

      setFormData({ email: "" });
      setFormError("");
      toast.success(response.message);
      console.log(response, "createnewLetter");
    } catch (error) {
      setFormData({ email: "" });
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <div className="footer-sec">
        <center>
      
          <div className="copyRight">
            <p>
              Readmax.com* is the sole owner of the information collected on
              this site. We will not sell, share or rent this information to any
              outside parties, except as outlined in the{" "}
              <Link className="copyRight" to="/privacypolicy">
                Privacy Policy
              </Link>
            </p>

            <span>CopyRight &copy; 2022 Readmax. All Right Reserved </span>
          </div>
        </center>
      </div> */}

      <section className="footer_wrapper">
        <div className="container">
          <div className="footer_grid">
            <div className="footer_column">
              {/* <a href="#">
                <img src={logo} alt="" className="img-fluid" />
              </a> */}
              <HashLink to="/">
                <img src={logo} alt="" className="img-fluid" />
              </HashLink>
              <p>
                Making students better readers through scientifically-proven
                Live Ink® technology.
              </p>
            </div>
            <div className="footer_column">
              <ul>
                <li className="list_heading">Product</li>
                <li>
                  {/* <a href="#">How It Work</a> */}

                  <HashLink smooth to="/#work-section">
                    How It Works
                  </HashLink>
                </li>
                <li>
                  {/* <a href="#">Research</a> */}
                  <HashLink to="/user/research">Research</HashLink>
                </li>
                <li>
                  {/* <a href="#">Pricing</a> */}
                  <HashLink to="/user/subscription#pricing-section">
                    Pricing
                  </HashLink>
                </li>
                <li>
                  <a href="/#download-extension">Chrome Extension</a>
                </li>
              </ul>
            </div>
            <div className="footer_column">
              <ul>
                <li className="list_heading">Company</li>
                {/* <li>
                  <a href="#">About Us</a>
                </li> */}
                <li>
                  {/* <a href="testimonial.html">Testimonials</a> */}
                  <HashLink to="/user/testimonial">Testimonials</HashLink>
                </li>
                <li>
                  {/* <a href="contact.html">Contact</a> */}
                  <HashLink to="/contact-us">Contact</HashLink>
                </li>
                <li>
                  <a href="/Privacypolicy">Privacy Policy</a>
                </li>
                <li>
                  <a href="#">Terms of Service</a>
                </li>
              </ul>
            </div>

            <div className="footer_column">
              <ul>
                <li className="list_heading">Resources</li>
                <li>
                  <HashLink to="/research/information">
                    Installation Guide
                  </HashLink>
                  {/* <a href="#">Installation Guide</a> */}
                </li>
                <li>
                  {/* <a href="#">FAQ</a> */}
                  <HashLink to="/research/information">FAQ</HashLink>
                </li>
                <li>
                  <a href="#">Support</a>
                </li>
                <li>
                  {/* <a href="#">Blog</a> */}
                  <HashLink to="/blogs?currentPage=1">Blog</HashLink>
                </li>
                <li>
                  <div className="d-flex flex-row">
                    <a
                      className="pageComponent pe-2"
                      data-label="LINK"
                      data-custominfo='{"custom_object":{"url":"https://play.google.com/store/apps/details?id=com.nnacres.app&amp;hl=en"}}'
                      title="Readmax Android App"
                      // target="_blank"
                      href="https://play.google.com/store/apps/details?id=com.readmax&hl=en"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <picture>
                        {/* <source
                          srcSet="https://static.99acres.com/universalapp/img/Play.png"
                          // Note: Use 'srcSet' (camelCase) for React props
                        /> */}
                        <img
                          // src="https://static.99acres.com/universalapp/img/Play.png"
                          src={googleStore}
                          width="140px"
                          height="40px"
                          alt="Readmax Android App"
                          title="Readmax"
                          loading="lazy" // Use 'loading' instead of 'decoding' for better performance
                          style={{
                            animationName: "gracefulimage",
                            animationDuration: "0.3s",
                            animationIterationCount: 1,
                            animationTimingFunction: "ease-in",
                          }}
                        />
                      </picture>
                    </a>

                    <a
                      className="pageComponent"
                      data-label="LINK"
                      // data-custominfo='{"custom_object":{"url":"https://play.google.com/store/apps/details?id=com.nnacres.app&amp;hl=en"}}'
                      data-custominfo='{"custom_object":{"url":"https://itunes.apple.com/in/app/99acres-property-search/id781765588"}}'
                      title="Readmax Android App"
                      // href="https://play.google.com/store/apps/details?id=com.nnacres.app&hl=en"
                      href="https://apps.apple.com/in/app/readmax/id6502988625"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <picture>
                        {/* <source srcSet="https://static.99acres.com/universalapp/img/ios.png" /> */}
                        <img
                          // src="https://static.99acres.com/universalapp/img/ios.png"
                          src={appStore}
                          width="140px"
                          height="40px"
                          alt="Readmax apply App"
                          title="Readmax"
                          loading="lazy"
                          style={{
                            animationName: "gracefulimage",
                            animationDuration: "0.3s",
                            animationIterationCount: 1,
                            animationTimingFunction: "ease-in",
                          }}
                        />
                      </picture>
                    </a>
                  </div>

                  {/* <a href="#">Blog</a> */}
                  {/* <HashLink to="/blogs?currentPage=1">Blog</HashLink> */}
                </li>
              </ul>
            </div>
            {/* <div className="footer_column">
              <ul>
                <li className="list_heading">Download our App</li>
                <li>
                  <div className="d-flex flex-row">
                    <a
                      className="pageComponent pe-2"
                      data-label="LINK"
                      data-custominfo='{"custom_object":{"url":"https://play.google.com/store/apps/details?id=com.nnacres.app&amp;hl=en"}}'
                      title="Readmax Android App"
                      
                      href="https://play.google.com/store/apps/details?id=com.readmax&hl=en"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <picture>
                        
                        <img
                          
                          src={googleStore}
                          width="140px"
                          height="40px"
                          alt="Readmax Android App"
                          title="Readmax"
                          loading="lazy"
                          style={{
                            animationName: "gracefulimage",
                            animationDuration: "0.3s",
                            animationIterationCount: 1,
                            animationTimingFunction: "ease-in",
                          }}
                        />
                      </picture>
                    </a>

                    <a
                      className="pageComponent"
                      data-label="LINK"
                   
                      data-custominfo='{"custom_object":{"url":"https://itunes.apple.com/in/app/99acres-property-search/id781765588"}}'
                      title="Readmax Android App"
                   
                      href="https://apps.apple.com/in/app/readmax/id6502988625"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <picture>
                       
                        <img
                          
                          src={appStore}
                          width="140px"
                          height="40px"
                          alt="Readmax apply App"
                          title="Readmax"
                          loading="lazy"
                          style={{
                            animationName: "gracefulimage",
                            animationDuration: "0.3s",
                            animationIterationCount: 1,
                            animationTimingFunction: "ease-in",
                          }}
                        />
                      </picture>
                    </a>
                  </div>

               
                </li>
              </ul>
            </div> */}
            {/* ------------News letter--------------- */}
            <div className="footer_column">
              <ul>
                <li className="list_heading">Newsletter</li>
                {/* <li>
                  <a href="#">About Us</a>
                </li> */}
                <li className="Subscribeletter">Sign up for our Newsletter</li>
                <li>
                  <form className="newFrom_letter" onSubmit={handleSubmit}>
                    <input
                      type="text"
                      placeholder="Email address"
                      className="newLetter"
                      name="email"
                      value={formData.email}
                      onChange={handlechange}
                    ></input>
                    <button className="newButton">
                      <svg
                        viewBox="0 0 20 20"
                        height="22ox"
                        width="20px"
                        className="fill-current"
                        style={{ fill: "currentColor" }}
                      >
                        <path d="M3.1175 1.17367L18.5025 9.63533C18.5678 9.6713 18.6223 9.72414 18.6602 9.78834C18.6982 9.85255 18.7182 9.92576 18.7182 10.0003C18.7182 10.0749 18.6982 10.1481 18.6602 10.2123C18.6223 10.2765 18.5678 10.3294 18.5025 10.3653L3.1175 18.827C3.05406 18.8619 2.98262 18.8797 2.91023 18.8785C2.83783 18.8774 2.76698 18.8575 2.70465 18.8206C2.64232 18.7838 2.59066 18.7313 2.55478 18.6684C2.51889 18.6056 2.50001 18.5344 2.5 18.462V1.53867C2.50001 1.46626 2.51889 1.39511 2.55478 1.33222C2.59066 1.26934 2.64232 1.21689 2.70465 1.18005C2.76698 1.1432 2.83783 1.12324 2.91023 1.12212C2.98262 1.121 3.05406 1.13877 3.1175 1.17367ZM4.16667 10.8337V16.3478L15.7083 10.0003L4.16667 3.65283V9.167H8.33333V10.8337H4.16667Z"></path>
                      </svg>
                    </button>
                  </form>
                </li>
              </ul>
            </div>
            {/* ------------------------- */}
          </div>
          <div className="copyright">
            <p>&copy; 2026 Readmax. All rights reserved.</p>
            {/* <ul className="privacy_text">
              <li>
                <a href="/Privacypolicy">Privacy Policy</a>
              </li>
              <li>
                <a href="#">Terms of Service</a>
              </li>
            </ul> */}
          </div>
        </div>
      </section>
    </>
  );
};
export default Footer;
